import { apiConstants } from './shared/config';

const authAccess = { roles: ['COSI_00007'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        redirect: { name: `${apiConstants.code}.communications` },
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-home" */ `./views/Home.vue`),
        meta: {
            auth: authAccess,
            hideHeaderName: true,
            title: 'home.title',
        }
    },
    {
        path: `/${apiConstants.code}/communications`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-communications" */ './views/communications/CommunicationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.communications`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-communications" */ './views/communications/CommunicationList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00710']},
                    hideHeaderName: true,
                    title: `communications.titles`,
                }
            },
            {
                path: 'add/:parentId?',
                name: `${apiConstants.code}.communications.add`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-communications" */ './views/communications/CommunicationDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00712']},
                    hideHeaderName: true,
                    title: `communications.title`,
                }
            },
            {
                path: 'timeline/:timelineId',
                name: `${apiConstants.code}.communications.timeline`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-communications" */ './views/communications/CommunicationDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00711']},
                    hideHeaderName: true,
                    title: `communications.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.communications.details`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-communications" */ './views/communications/CommunicationDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00711']},
                    hideHeaderName: true,
                    title: 'Comunicação',
                }
            }
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00710']},
            hideHeaderName: true,
            title: `communications.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/vehicles`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-vehicles" */ './views/vehicles/VehicleBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.vehicles`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-vehicles" */ './views/vehicles/VehicleList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00690']},
                    hideHeaderName: true,
                    title: `vehicles.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.vehicles.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-vehicles" */ './views/vehicles/VehicleDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00692']},
                    hideHeaderName: true,
                    title: `vehicles.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.vehicles.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-vehicles" */ './views/vehicles/VehicleDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00691']},
                    hideHeaderName: true,
                    title: `vehicles.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00690']},
            hideHeaderName: true,
            title: `vehicles.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/terrestrialresources`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-terrestrialresources" */ './views/terrestrialresources/TerrestrialResourceBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.terrestrialresources`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-terrestrialresources" */ './views/terrestrialresources/TerrestrialResourceList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00690x']},
                    hideHeaderName: true,
                    title: `terrestrialresources.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.terrestrialresources.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-terrestrialresources" */ './views/terrestrialresources/TerrestrialResourceDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00692x']},
                    hideHeaderName: true,
                    title: `terrestrialresources.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.terrestrialresources.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-terrestrialresources" */ './views/terrestrialresources/TerrestrialResourceDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00691x']},
                    hideHeaderName: true,
                    title: `terrestrialresources.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00690x']},
            hideHeaderName: true,
            title: `terrestrialresources.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/aerialresources`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-aerialresources" */ './views/aerialresources/AerialResourceBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.aerialresources`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-aerialresources" */ './views/aerialresources/AerialResourceList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00690']},
                    hideHeaderName: true,
                    title: `aerialresources.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.aerialresources.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-aerialresources" */ './views/aerialresources/AerialResourceDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00692']},
                    hideHeaderName: true,
                    title: `aerialresources.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.aerialresources.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-aerialresources" */ './views/aerialresources/AerialResourceDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00691']},
                    hideHeaderName: true,
                    title: `aerialresources.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00690']},
            hideHeaderName: true,
            title: `aerialresources.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/radios`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-radios" */ './views/radios/RadioBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.radios`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-radios" */ './views/radios/RadioList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00700']},
                    hideHeaderName: true,
                    title: `radios.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.radios.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-radios" */ './views/radios/RadioDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00702']},
                    hideHeaderName: true,
                    title: `radios.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.radios.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-radios" */ './views/radios/RadioDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00701']},
                    hideHeaderName: true,
                    title: `radios.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00700']},
            hideHeaderName: true,
            title: `radios.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/agents`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-agents" */ './views/agents/AgentBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.agents`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-agents" */ './views/agents/AgentList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00680']},
                    hideHeaderName: true,
                    title: `agents.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.agents.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-agents" */ './views/agents/AgentDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00682']},
                    hideHeaderName: true,
                    title: `agents.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.agents.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-agents" */ './views/agents/AgentDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00681']},
                    hideHeaderName: true,
                    title: `agents.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00680']},
            hideHeaderName: true,
            title: `agents.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/report`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-report" */ './views/report/AdminReportBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.report`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-report" */ './views/report/AdminReportList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00750']},
                    hideHeaderName: true,
                    title: 'Relatórios',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.report.details`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-report" */ './views/report/AdminReportDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00751']},
                    hideHeaderName: true,
                    title: 'Relatório',
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00750']},
            hideHeaderName: true,
            title: 'Relatórios',
        }
    },
    {
        path: `/${apiConstants.code}/shifts`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-shifts" */ './views/shift/ShiftBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.shifts`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-shifts" */ './views/shift/ShiftList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00760']},
                    hideHeaderName: true,
                    title: `shifts.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.shifts.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-shifts" */ './views/shift/ShiftDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00762']},
                    hideHeaderName: true,
                    title: `shifts.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.shifts.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosicentral-shifts" */ './views/shift/ShiftDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['COSI_00761']},
                    hideHeaderName: true,
                    title: `shifts.title`,
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['COSI_00760']},
            hideHeaderName: true,
            title: `shifts.titles`,
        }
    },
];

export default routes;
